import { Region, api } from 'api';
import { queryCacheDuration } from 'const';
import { rtkQueryApi } from 'store/rtkQueryApi';

export const regionsApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getRegions: builder.query<Region[], void>({
      query: () => {
        return api.region.getRegions();
      },
      keepUnusedDataFor: queryCacheDuration,
    }),
  }),
});

export const { useGetRegionsQuery } = regionsApi;
